import ReportingIcon from "@mui/icons-material/AssessmentOutlined";
import { filterSousMenu } from "menu-items";
import { UserModule } from "types";
import { LINKS } from "utils/constant";

const sousmenus = [
  {
    id: "rapport_codir",
    title: "Synthèse CODIR",
    type: "item",
    url: LINKS.reporting.codir,
    caption: "Pilotage consolidé des activités",
  },
  {
    id: "rapport_tdf",
    title: "Transport de fonds",
    type: "item",
    url: LINKS.reporting.operationnelle,
    caption: "Activité, dessertes et tournées TDF",
  },
  {
    id: "rapport_stock",
    title: "Gestion de stock",
    type: "item",
    url: LINKS.reporting.stock,
    caption: "Stocks disponibles et seuils d’alerte",
  },
  {
    id: "rapport_ca",
    title: "Chiffre d'affaires",
    type: "item",
    url: LINKS.reporting.ca,
    caption: "Consulter reporting chiffres d'affaires",
  },
];

export const buildReportingMenu = (userModule: UserModule) => {
  const data = filterSousMenu(userModule, sousmenus);

  if (data.length) {
    return {
      id: "group-reporting",
      type: "group",
      children: [
        {
          id: "reporting",
          title: "Reporting",
          type: "collapse",
          icon: ReportingIcon,
          children: data,
        },
      ],
    };
  }
  return null;
};
